import React from "react";

interface Props {
  ingredientsCost: number;
  additionalCost: number;
  batchSize: number;
  productCostPrice?: number;
}

export const RecipeCostSummary: React.FC<Props> = ({
  ingredientsCost,
  additionalCost,
  batchSize,
  productCostPrice,
}) => {
  const totalCost = ingredientsCost + additionalCost;
  const unitCost = totalCost / (batchSize || 1);

  return (
    <div className="bg-gray-50 p-4 rounded-md border border-gray-100 mb-4 flex flex-col gap-2">
      <div className="flex items-center justify-between text-xs text-gray-500">
        <span>Ingredients Cost:</span>
        <span className="font-medium">Rs. {ingredientsCost.toFixed(2)}</span>
      </div>
      <div className="flex items-center justify-between text-xs text-gray-500">
        <span>Additional Cost (e.g. Water, Elect.):</span>
        <span className="font-medium">Rs. {additionalCost.toFixed(2)}</span>
      </div>
      <div className="flex items-center justify-between border-t border-gray-200 pt-2 text-xs font-semibold text-gray-700">
        <span>Total Recipe Cost:</span>
        <span>Rs. {totalCost.toFixed(2)}</span>
      </div>
      <div className="flex items-center justify-between text-xs text-gray-500">
        <span>Yield / Batch Size:</span>
        <span className="font-medium">{batchSize} units</span>
      </div>
      <div className="flex items-center justify-between border-t border-dashed border-gray-200 pt-2 text-sm font-bold text-gray-800">
        <span>Calculated Unit Cost:</span>
        <span className="text-indigo-600">
          Rs. {unitCost.toFixed(2)} / unit
        </span>
      </div>
      {productCostPrice !== undefined && (
        <div className="flex items-center justify-between text-[11px] text-gray-400 border-t border-gray-100 pt-1">
          <span>Current Product Cost:</span>
          <span>Rs. {productCostPrice.toFixed(2)}</span>
        </div>
      )}
    </div>
  );
};
